<template>
  <div class="wt2-progress-native-component">
    <span v-if="labelLeft" :for="guid" class="-label-left" v-text="labelLeft" />

    <hybrid-progress :id="guid" :value="value" :max="max" />
  </div>
</template>

<script>
import app from 'app';

/**
 * progress visual becomes "Indeterminate" if no progress or reached max value
 */
const HybridProgress = app.Vue.extend({
  functional: true,

  render(h, { data }) {
    if (
      !window.isFinite(data.attrs.value) ||
      data.attrs.value < 0 ||
      data.attrs.value >= data.attrs.max
    ) {
      delete data.attrs.value;
    }

    return h('progress', data);
  },
});
export default {
  components: {
    HybridProgress,
  },

  props: {
    labelLeft: {
      type: String,
      required: false,
      default: '',
    },
    max: {
      type: Number,
      required: false,
      default: 1,
    },
    value: {
      type: [Boolean, Number],
      required: false,
      default: undefined,
    },
  },

  data() {
    return {
      guid: app.guid(),
    };
  },
};
</script>
